// Generated by scripts/build-map-library.ts.
const libraryAssetIds = new Set<string>([
  "hot-springs-iceland",
  "waterfalls-iceland",
  "waterfalls-norway",
  "castles-united-kingdom",
  "closed-airports-uk",
  "closed-airports-france",
  "closed-airports-world",
  "earthquakes-world-2020-2025-m6",
  "shipwrecks-us-approach-charts",
  "atlantic-storm-tracks-2005",
  "meteorites-historical-sample",
  "unesco-world-heritage-sites",
  "alpine-ski-resorts",
  "hot-springs-united-states",
  "hot-springs-japan",
  "waterfalls-new-zealand",
  "alpine-mountain-summits",
  "world-holocene-volcanoes",
  "international-dark-sky-places",
  "egypt-pyramids",
  "world-roller-coasters",
  "uk-film-television-locations",
  "europe-second-world-war-battle-sites",
  "western-front-first-world-war-battle-sites",
  "us-ghost-towns",
  "world-scheduled-service-airports",
  "world-seaports",
  "world-volcanoes-erupted-2000-2025",
  "world-cities-one-million",
  "world-national-capitals",
  "world-time-zone-boundaries",
  "world-major-watersheds",
  "mediterranean-sea-turtle-observations-2020-2025",
  "world-formula-one-circuits",
  "paris-2024-olympic-venues",
  "world-spaceports",
  "us-national-parks",
  "us-national-forests",
  "us-state-parks",
  "us-national-park-campgrounds",
  "us-public-ev-fast-charging-stations",
  "us-tesla-supercharger-locations",
  "paris-bike-share-stations",
  "world-power-plants-wri-archive",
  "world-oil-pipelines",
  "world-gas-pipelines",
  "japan-earthquakes-2020-2025",
  "california-earthquakes-2020-2025",
  "north-atlantic-hurricane-tracks-2010-2025",
  "us-tornado-events-2020-2025",
  "world-tsunami-source-events-1900-2025",
  "california-wildfire-perimeters-2020-2025",
  "world-recorded-landslides-glc-archive",
  "us-wilderness-areas",
  "us-annual-pm25-monitors-2025",
  "world-nuclear-power-plants",
  "world-wind-farms",
  "world-solar-farms",
  "world-coal-mines",
  "alpine-glacier-outlines-2015-2016",
  "large-wetlands-florida",
  "large-reservoirs-world",
  "florida-regulatory-floodways-2024",
  "us-county-population-density-2025",
  "tectonic-plate-boundaries-world",
  "terrestrial-ecoregions-world",
  "terrestrial-biomes-world",
  "marine-protected-areas-us",
  "bird-observations-uk-2025",
  "humpback-whale-records-north-atlantic",
  "biodiversity-hotspots-world",
  "red-panda-records-world",
  "uk-named-hiking-routes",
  "netherlands-cycle-routes",
  "portugal-beaches",
  "australia-surf-locations",
  "slovenia-cave-entrances",
  "australia-mapped-coral-reefs",
  "germany-castles",
  "france-castles",
  "ireland-castles",
  "italy-roman-archaeological-sites",
  "greece-ancient-archaeological-sites",
  "france-museums",
  "uk-art-galleries",
  "european-botanical-gardens",
  "us-zoos",
  "european-aquariums",
  "european-theme-parks",
  "us-lighthouses",
  "uk-historic-battlefield-sites",
  "paris-cemeteries",
  "uk-railway-stations",
  "european-passenger-rail-network",
  "european-high-speed-railway-lines",
  "paris-metro-lines",
  "greek-island-ferry-routes",
  "us-named-dams",
  "world-oil-refineries",
  "france-wineries",
  "uk-breweries",
  "european-football-stadiums",
  "uk-universities",
  "kenya-hospitals",
  "uk-public-libraries",
  "london-public-toilets",
  "rome-drinking-water-fountains",
  "berlin-playgrounds",
  "london-dog-parks",
  "uk-picnic-sites",
  "world-astronomical-observatories",
  "k-12-schools-ks-schools-kansas-8e133df7",
  "kentucky-city-hall-locations-81ff6e43",
  "airports-in-the-maryland-transit-source-collection-49efc4d2",
  "mbta-bus-stops-in-the-boston-area-transit-network-massachusetts-2cd3ccdd",
  "acute-care-hospitals-in-nj-new-jersey-563e3241",
  "fire-stations-oregon-98d40ff0",
  "utah-city-and-town-locations-cities-towns-locations-e103240f",
  "historic-washington-dc-boundary-stones-washington-dc-and-original-district-boundary-8599ea23",
  "kentucky-hospitals-4e1aa5e0",
  "commuter-rail-stations-in-the-boston-area-source-april-2015-boston-area-commuter-rail-network-705e579f",
  "county-centre-points-in-new-jersey-62316f2a",
  "oregon-water-rights-points-of-diversion-groundwater-agriculture-6820b0b7",
  "protected-landmarks-in-seattle-45aea8a6",
  "ct-dcf-region-boundaries-connecticut-6b0650d8",
  "kentucky-libraries-61465a3a",
  "mbta-rapid-transit-stops-in-the-boston-area-transit-network-massachusetts-68742efa",
  "city-boundaries-in-michigan-e25c70dd",
  "long-term-care-facilities-of-new-jersey-55a37fe7",
  "wildfire-related-facilities-fire-lookouts-current-oregon-7d3180da",
  "utah-county-boundaries-counties-df568070",
  "ct-dcf-town-boundaries-connecticut-7ddf34b7",
  "kentucky-public-schools-1a5a178b",
  "county-michigan-0418b8bb",
  "mature-support-hospitals-of-nj-new-jersey-10631348",
  "oregon-congressional-districts-adopted-in-2021-418fca4e",
  "blue-water-trails-kentucky-fb940416",
  "public-water-supply-source-locations-in-massachusetts-8eb46e08",
  "county-boundary-lines-in-oregon-and-washington-28c49d1e",
  "utah-municipal-boundaries-municipalities-613a3471",
  "research-station-facilities-united-states-aa69dd10",
  "michigan-state-house-districts-v17a-0c6c907f",
  "groundwater-restricted-areas-gw-restricted-areas-oregon-1bd71962",
  "neighbourhood-design-guideline-areas-in-seattle-891afc8a",
  "michigan-state-senate-districts-v17a-2ec4229f",
  "utah-school-district-boundaries-school-districts-675b0757",
  "kentucky-911-psap-boundaries-8090fa17",
  "michigan-u-s-congressional-districts-v17a-4e655f30",
  "existing-bike-facilities-in-seattle-b07d7604",
  "kentucky-state-forest-boundaries-1a018f69",
  "oregon-state-boundary-850c2c47",
  "seattle-city-limits-1d0067f1",
  "prairie-chicken-hunting-zones-in-kansas-69c62d3f",
  "kentucky-state-park-boundaries-e2d00c85",
  "utah-us-congress-districts-2026-to-2032-7b77fa0d",
  "pronghorn-archery-hunting-units-in-kansas-d82114dd",
  "utah-public-safety-answering-point-locations-psaplocations-1c569a51",
  "pronghorn-rifle-hunting-units-in-kansas-8579e8c0",
  "kentucky-weather-observation-points-kymesonet-points-c884e845",
  "state-of-michigan-boundary-state-boundary-16950cc4",
  "historical-urban-centre-neighbourhood-monitoring-areas-in-seattle-53b66a54",
  "elk-hunting-units-in-kentucky-41c109d9",
  "kentucky-time-zone-line-66fd8d62",
  "historical-woodland-density-of-the-conterminous-united-states-1873-bb64b7ca",
  "zone-i-public-well-protection-areas-in-massachusetts-b1332d79",
  "indian-land-cessions-in-the-united-states-1fc733de",
  "village-michigan-3d34bc8d",
  "approved-zone-ii-wellhead-protection-areas-in-massachusetts-9c276f58",
  "pacific-island-territories-and-freely-associated-state-boundaries-us-pacific-territories-and-fr-459b3c92",
  "roadless-areas-colorado-roadless-rule-dea9370d",
  "roadless-areas-idaho-roadless-rule-f51ff4a6",
  "watershed-condition-classification-priority-watersheds-us-forest-service-lands-6280c843",
  "special-uses-communications-sites-us-forest-service-lands-45ae0efb",
  "american-indian-alaska-native-and-native-hawaiian-areas-44ea21b2",
  "amtrak-rail-stops-in-the-maryland-transit-source-collection-d80224ad",
  "oregon-water-rights-points-of-diversion-groundwater-commercial-c7bdf465",
  "baltimore-metro-subway-parking-in-the-maryland-transit-source-collection-7d2340eb",
  "oregon-water-rights-points-of-diversion-groundwater-domestic-20a376b6",
  "baltimore-metro-subwaylink-stations-in-the-maryland-transit-source-collection-bbb94e76",
  "oregon-water-rights-points-of-diversion-groundwater-fish-ef4ec9c4",
  "district-owned-land-address-points-in-washington-dc-47affd48",
  "light-rail-parking-in-the-maryland-transit-source-collection-f7ce128b",
  "light-raillink-stations-in-the-maryland-transit-source-collection-a880f3d2",
  "property-assessment-neighbourhoods-in-washington-dc-a136ddd2",
  "marc-train-parking-in-the-maryland-transit-source-collection-de643870",
  "oregon-water-rights-points-of-diversion-groundwater-livestock-e0ef89b7",
  "property-assessment-sub-neighbourhoods-in-washington-dc-a30884f0",
  "marc-trains-stations-in-the-maryland-transit-source-collection-96160c90",
  "oregon-water-rights-points-of-diversion-groundwater-mining-2dee2ef4",
  "mta-bus-parking-in-the-maryland-transit-source-collection-8c166a00",
  "mbta-bus-routes-in-the-boston-area-transit-network-massachusetts-0d57afa1",
  "fixed-transit-routes-in-the-twin-cities-metropolitan-area-ef6540fe",
  "oregon-water-rights-points-of-diversion-groundwater-miscellaneous-uses-69995360",
  "mta-bus-stops-in-the-maryland-transit-source-collection-021a524e",
  "mbta-rapid-transit-lines-in-the-boston-area-transit-network-massachusetts-cafd5699",
  "oregon-water-rights-points-of-diversion-groundwater-municipal-1c4c31c0",
  "alaska-landslide-inventory-web-layer-landslide-flanks-840cfbab",
  "sea-ports-in-the-maryland-transit-source-collection-dffc215c",
  "oregon-water-rights-points-of-diversion-groundwater-power-ac672260",
  "alaska-landslide-inventory-web-layer-landslide-toe-c33c1796",
  "district-structure-outlines-in-washington-dc-f8358cfe",
  "wmata-metro-bus-stops-in-the-maryland-transit-source-collection-ed6dbe50",
  "oregon-water-rights-points-of-diversion-groundwater-recreation-40fd1e41",
  "alaska-landslide-inventory-web-layer-scarps-b98b5a48",
  "wmata-metro-station-entrances-in-the-maryland-transit-source-collection-754d8271",
  "massachusetts-municipalities-massachusetts-municipalities-lines-d053c882",
  "oregon-water-rights-points-of-diversion-groundwater-wildlife-954e4440",
  "wmata-metro-stops-in-the-maryland-transit-source-collection-de756136",
  "oregon-water-rights-points-of-diversion-storage-agriculture-e5d27e00",
  "oregon-water-rights-points-of-diversion-storage-commercial-dd5d75ab",
  "oregon-water-rights-points-of-diversion-storage-domestic-9571bb8f",
  "airport-runways-in-the-maryland-transit-source-collection-652ccb40",
  "oregon-water-rights-points-of-diversion-storage-fish-d4eeeefc",
  "amtrak-rail-lines-in-the-maryland-transit-source-collection-1ff06595",
  "interim-wellhead-protection-areas-in-massachusetts-ca4fc9db",
  "baltimore-metro-subway-line-in-the-maryland-transit-source-collection-3758194c",
  "oregon-water-rights-points-of-diversion-storage-irrigation-e99b9eef",
  "multi-use-trails-seattle-only-in-seattle-db7874e7",
  "light-rail-line-in-the-maryland-transit-source-collection-7f057ef2",
  "planned-bike-facilities-in-seattle-7c0ab696",
  "marc-train-lines-in-the-maryland-transit-source-collection-e31d1c2a",
  "oregon-water-rights-points-of-diversion-storage-mining-e07694ff",
  "mta-bus-lines-in-the-maryland-transit-source-collection-d8ee8a12",
  "historical-urban-centre-and-village-growth-monitoring-areas-in-seattle-abe8349c",
  "navigable-waterways-in-the-maryland-transit-source-collection-6de674aa",
  "oregon-water-rights-points-of-diversion-storage-municipal-a66ff438",
  "wmata-metro-bus-lines-in-the-maryland-transit-source-collection-c2b224a5",
  "oregon-water-rights-points-of-diversion-storage-power-6f45935e",
  "wmata-metro-lines-in-the-maryland-transit-source-collection-5e5cdd78",
  "oregon-water-rights-points-of-diversion-storage-recreation-bad8884e",
  "oregon-water-rights-points-of-diversion-surface-water-agriculture-98b33850",
  "oregon-water-rights-points-of-diversion-surface-water-commercial-a0ab6421",
  "oregon-water-rights-points-of-diversion-surface-water-fish-11cec114",
  "oregon-water-rights-points-of-diversion-surface-water-mining-b7782481",
  "oregon-water-rights-points-of-diversion-surface-water-miscellaneous-uses-90ab353c",
  "oregon-water-rights-points-of-diversion-surface-water-municipal-b53c37bb",
  "oregon-water-rights-points-of-diversion-surface-water-power-b7c688e1",
  "oregon-water-rights-points-of-diversion-surface-water-recreation-6aa5bacd",
  "oregon-water-rights-points-of-diversion-surface-water-wildlife-04a5c396",
  "congressional-districts-oregon-house-sb-882-d9aaafd0",
  "congressional-districts-oregon-senate-sb-882-2ba868b5",
  "urban-growth-boundaries-ugb-2025-oregon-821a1948",
  "oregon-water-rights-places-of-use-groundwater-agriculture-92369074",
  "oregon-water-rights-places-of-use-groundwater-commercial-5a76c3a2",
  "oregon-water-rights-places-of-use-groundwater-domestic-6f9bc461",
  "oregon-water-rights-places-of-use-groundwater-fish-734b23bd",
  "oregon-water-rights-places-of-use-groundwater-livestock-059fc890",
  "oregon-water-rights-places-of-use-groundwater-mining-d637f62b",
  "oregon-water-rights-places-of-use-groundwater-miscellaneous-uses-2b227519",
  "oregon-water-rights-places-of-use-groundwater-power-d24eb9c6",
  "oregon-water-rights-places-of-use-groundwater-recreation-aeb6fd22",
  "affordable-housing-locations-in-washington-dc-651db0d7",
  "oregon-water-rights-places-of-use-groundwater-wildlife-13b53f09",
  "oregon-water-rights-places-of-use-storage-agriculture-98eabcd1",
  "district-real-estate-portfolio-locations-in-washington-dc-335f662d",
  "oregon-water-rights-places-of-use-storage-commercial-72e36287",
  "development-project-locations-in-washington-dc-b0aa1992",
  "oregon-water-rights-places-of-use-storage-domestic-19463b58",
  "liquor-licence-locations-in-washington-dc-7b3c6b8e",
  "oregon-water-rights-places-of-use-storage-fish-2d15b40a",
  "oregon-water-rights-places-of-use-storage-instream-3679d5dc",
  "equity-impact-enterprise-grant-locations-in-washington-dc-6d3d54cb",
  "oregon-water-rights-places-of-use-storage-irrigation-acc06758",
  "home-occupancy-permit-locations-in-washington-dc-b6b6ba0c",
  "notary-public-locations-in-washington-dc-331a0f07",
  "oregon-water-rights-places-of-use-storage-mining-000d1ce9",
  "robust-retail-small-business-grant-locations-in-washington-dc-a5712233",
  "air-rights-lots-in-washington-dc-700389b4",
  "oregon-water-rights-places-of-use-storage-municipal-b66d4322",
  "oregon-water-rights-places-of-use-storage-power-9ffe8078",
  "federal-appropriation-areas-in-washington-dc-c4270ed7",
  "oregon-water-rights-places-of-use-storage-recreation-68e7d829",
  "condominium-approval-lots-in-washington-dc-2579ca22",
  "oregon-water-rights-places-of-use-storage-wildlife-99941747",
  "military-base-boundaries-in-washington-dc-759335c1",
  "oregon-water-rights-places-of-use-surface-water-agriculture-cd815cb7",
  "oregon-water-rights-places-of-use-surface-water-commercial-105e5a9b",
  "public-easement-lines-in-washington-dc-8785c7a7",
  "oregon-water-rights-places-of-use-surface-water-fish-db9f7745",
  "alcohol-licence-moratorium-zones-in-washington-dc-27519382",
  "oregon-water-rights-places-of-use-surface-water-mining-8004283c",
  "oregon-water-rights-places-of-use-surface-water-miscellaneous-uses-09f306e1",
  "oregon-water-rights-places-of-use-surface-water-power-bfd001df",
  "oregon-water-rights-places-of-use-surface-water-recreation-098ff3ba",
  "oregon-water-rights-places-of-use-surface-water-wildlife-7902211c",
  "utah-law-enforcement-boundaries-55e33513",
  "intermediate-school-district-michigan-7753bb84",
  "cancelled-liquor-licence-locations-in-washington-dc-d4700292",
  "kentucky-911-fire-response-service-boundaries-9d456e67",
  "kentucky-911-law-enforcement-response-service-boundaries-cc211677",
  "maryland-political-boundaries-county-boundaries-municipal-boundaries-detailed-b45fdd50",
  "massachusetts-municipalities-massachusetts-municipalities-areas-270e5ac0",
  "minor-civil-division-cities-townships-michigan-fe4de171",
  "mature-support-election-districts-for-new-jersey-govt-admin-election-district-1affe434",
  "oregon-state-parks-223ab63d",
  "school-district-michigan-34549e84",
  "oregon-wetland-database-i-lwi-wetlands-ac989798",
  "mature-support-ward-boundaries-for-new-jersey-govt-admin-ward-21f99f04",
  "utah-ems-response-areas-emsresponse-areas-3f7e1ae5",
  "ct-housing-data-hub-permitting-decd-connecticut-5c67609b",
  "township-michigan-e2f1b947",
  "oregon-wildland-urban-interface-3c1da301",
  "utah-zip-code-areas-zip-codes-bcb50950",
  "urban-growth-boundaries-or-ugb-history-oregon-9639ade0",
  "surface-water-supply-protection-areas-zone-a-b-c-surface-water-protection-areas-zone-a-massachu-72471b31",
  "healthy-forest-restoration-act-us-forest-service-lands-973b6a06",
  "public-hunting-areas-in-kentucky-b06dba37",
  "land-management-planning-unit-us-forest-service-lands-79c310be",
  "voting-precincts-in-michigan-may-2026-source-af80d08f",
  "national-forest-lands-with-nationally-designated-management-or-use-limitations-us-forest-servic-8b0dde82",
  "rivers-eligible-or-suitable-for-wild-and-scenic-designation-contiguous-united-states-alaska-haw-6ab2f547",
  "designated-wild-and-scenic-river-lines-united-states-and-puerto-rico-e81b0428",
  "tongass-landslide-areas-f5e60acd",
  "gaoa-project-summary-us-forest-service-lands-6d0cbbbb",
  "existing-vegetation-region-5-great-basin-02ec602b",
  "ecological-sections-of-the-contiguous-united-states-2007-b5bc1b0b",
  "district-land-boundaries-in-washington-dc-a842f97c",
  "historic-asset-inventory-areas-in-massachusetts-47e47f3d",
  "federal-land-from-property-tax-records-in-washington-dc-e2707982",
  "recorded-land-boundary-changes-in-washington-dc-5bf66bde",
  "surface-water-supply-protection-areas-zone-a-b-c-surface-water-protection-areas-zone-b-massachu-4f310989",
  "property-square-boundaries-in-washington-dc-a044aac2",
  "oregon-water-rights-places-of-use-groundwater-municipal-5b5e0a59",
  "oregon-water-rights-places-of-use-storage-miscellaneous-uses-4bfea372",
  "oregon-water-rights-places-of-use-surface-water-domestic-5045906e",
  "oregon-water-rights-places-of-use-surface-water-livestock-d9d0287d",
  "oregon-water-rights-places-of-use-surface-water-municipal-1dd2daa3",
  "forest-service-office-locations-3fc72a16",
  "national-grassland-boundaries-95a8f023",
  "wild-and-scenic-river-areas-841039d9",
  "national-park-service-public-parking-areas-aca0e962",
  "wildfire-crisis-strategy-project-areas-68b33551",
  "massachusetts-municipal-boundaries-simplified-coast-2ebb1cf4",
  "maryland-municipal-boundaries-simplified-5115c709",
  "us-county-population-growth-2020-2025",
  "us-county-household-income-2020-2024",
  "us-county-home-ownership-2020-2024",
  "us-county-housing-age-2020-2024",
  "great-britain-road-traffic-2025",
  "world-100",
  "world-1500",
  "world-1800",
  "world-1914"
]);

export function isLibraryAssetId(id: string): boolean {
  return libraryAssetIds.has(id);
}
